import { am } from './utils';

import httpClient from '@/utils/httpClient';

const GET_SYNC_STATUS = am('GET_EMAILS_SYNC_STATUS');
const GET_SCHEDULER_STATUS = am('GET_EMAILS_SCHEDULER_STATUS');
const GET_QUEUE_STATS = am('GET_EMAILS_QUEUE_STATS');
const GET_DEAD_LETTER = am('GET_EMAILS_DEAD_LETTER');

const state = {
  syncStatus: [],
  isSyncStatusPending: false,
  isSyncStatusFailed: false,

  schedulerStatus: null,
  isSchedulerStatusPending: false,
  isSchedulerStatusFailed: false,

  queueStats: null,
  isQueueStatsPending: false,
  isQueueStatsFailed: false,

  deadLetter: { total: 0, page: 1, size: 20, items: [] },
  isDeadLetterPending: false,
  isDeadLetterFailed: false,

  lastRefreshedAt: null
};

const mutations = {
  [GET_SYNC_STATUS.STARTED](state) {
    state.isSyncStatusPending = true;
    state.isSyncStatusFailed = false;
  },
  [GET_SYNC_STATUS.FAILED](state) {
    state.isSyncStatusPending = false;
    state.isSyncStatusFailed = true;
  },
  [GET_SYNC_STATUS.COMPLETED](state, data) {
    state.isSyncStatusPending = false;
    state.syncStatus = Array.isArray(data) ? data : [];
    state.lastRefreshedAt = new Date();
  },

  [GET_SCHEDULER_STATUS.STARTED](state) {
    state.isSchedulerStatusPending = true;
    state.isSchedulerStatusFailed = false;
  },
  [GET_SCHEDULER_STATUS.FAILED](state) {
    state.isSchedulerStatusPending = false;
    state.isSchedulerStatusFailed = true;
  },
  [GET_SCHEDULER_STATUS.COMPLETED](state, data) {
    state.isSchedulerStatusPending = false;
    state.schedulerStatus = data;
  },

  [GET_QUEUE_STATS.STARTED](state) {
    state.isQueueStatsPending = true;
    state.isQueueStatsFailed = false;
  },
  [GET_QUEUE_STATS.FAILED](state) {
    state.isQueueStatsPending = false;
    state.isQueueStatsFailed = true;
  },
  [GET_QUEUE_STATS.COMPLETED](state, data) {
    state.isQueueStatsPending = false;
    state.queueStats = data;
  },

  [GET_DEAD_LETTER.STARTED](state) {
    state.isDeadLetterPending = true;
    state.isDeadLetterFailed = false;
  },
  [GET_DEAD_LETTER.FAILED](state) {
    state.isDeadLetterPending = false;
    state.isDeadLetterFailed = true;
  },
  [GET_DEAD_LETTER.COMPLETED](state, data) {
    state.isDeadLetterPending = false;
    state.deadLetter = {
      total: data?.total || 0,
      page: data?.page || 1,
      size: data?.size || 20,
      items: Array.isArray(data?.items) ? data.items : []
    };
  }
};

const actions = {
  async getSyncStatus({ commit }) {
    commit(GET_SYNC_STATUS.STARTED);
    try {
      const data = await httpClient.get('/api/ms-graph-email-connector/emails/sync-status');
      commit(GET_SYNC_STATUS.COMPLETED, data);
    } catch (e) {
      commit(GET_SYNC_STATUS.FAILED);
    }
  },

  async getSchedulerStatus({ commit }) {
    commit(GET_SCHEDULER_STATUS.STARTED);
    try {
      const data = await httpClient.get('/api/ms-graph-email-connector/scheduler/status');
      commit(GET_SCHEDULER_STATUS.COMPLETED, data);
    } catch (e) {
      commit(GET_SCHEDULER_STATUS.FAILED);
    }
  },

  async getQueueStats({ commit }, { sample = 500 } = {}) {
    commit(GET_QUEUE_STATS.STARTED);
    try {
      const data = await httpClient.get(
        `/api/hub-correspondence/correspondence/queue/stats?sample=${sample}`,
      );
      commit(GET_QUEUE_STATS.COMPLETED, data);
    } catch (e) {
      commit(GET_QUEUE_STATS.FAILED);
    }
  },

  async getDeadLetter({ commit }, { page = 1, size = 20 } = {}) {
    commit(GET_DEAD_LETTER.STARTED);
    try {
      const data = await httpClient.get(
        `/api/hub-correspondence/correspondence/queue/dead-letter?page=${page}&size=${size}`,
      );
      commit(GET_DEAD_LETTER.COMPLETED, data);
    } catch (e) {
      commit(GET_DEAD_LETTER.FAILED);
    }
  },

  async retryDeadLetter({ dispatch, state }, jobId) {
    await httpClient.post(
      `/api/hub-correspondence/correspondence/queue/dead-letter/${encodeURIComponent(jobId)}/retry`,
    );
    await dispatch('getDeadLetter', {
      page: state.deadLetter.page,
      size: state.deadLetter.size,
    });
  },

  async removeDeadLetter({ dispatch, state }, jobId) {
    await httpClient.post(
      `/api/hub-correspondence/correspondence/queue/dead-letter/${encodeURIComponent(jobId)}/remove`,
    );
    await dispatch('getDeadLetter', {
      page: state.deadLetter.page,
      size: state.deadLetter.size,
    });
  },

  async refreshAll({ dispatch, state }) {
    await Promise.all([
      dispatch('getSyncStatus'),
      dispatch('getSchedulerStatus'),
      dispatch('getQueueStats'),
      dispatch('getDeadLetter', { page: state.deadLetter.page, size: state.deadLetter.size })
    ]);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
